<template lang="pug">
  #reset
    md-button.md-raised.md-accent(@click='$refs.reset.open()') リセット
    md-dialog-confirm(
      ref='reset',
      md-title='リセット確認',
      md-ok-text='リセット',
      md-cancel-text='中止',
      md-content-html='データを全てリセットします。<br>元には戻せません。よろしいですか？',
      @close='onClose'
    )
</template>

<script>
export default {
  methods: {
    onClose (choice) {
      if (choice === 'ok') {
        this.$store.commit('reset')
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Reset.vue